<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="mb-3">
  <div class="row m-0 col-md-12 p-0 mb-3">
    <div
      class="col-12 col-sm-6 col-md-4 p-2"
      *ngFor="let item of dashboardData; let ind = index"
      (click)="getDetail(item.ShortName)"
    >
      <div class="lms-dashboard-card">
        <div class="lms-card-accent"></div>
        <div class="lms-card-body">
          <div class="lms-icon-wrapper">
            <img
              src="{{ iconname }}{{ item.IconImage }}"
              alt="icon"
              class="lms-card-icon"
            />
          </div>
          <div class="lms-card-info">
            <span class="lms-card-count">{{ item.ItemCount }}</span>
            <span class="lms-card-title">{{ item.IconName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
